import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const submitChargeCardApplicationMutation = gql`
  mutation SubmitChargeCardApplication(
    $idempotencyId: IdempotencyToken!
    $input: SubmitChargeCardApplicationInput!
  ) {
    submitChargeCardApplication(idempotencyId: $idempotencyId, input: $input) {
      ... on SubmitChargeCardApplicationSuccess {
        applicationId
        chargeCardApplicationStatus
      }
      ... on SubmitChargeCardApplicationMissingAgreement {
        ...error
      }
      ... on SubmitChargeCardApplicationValidationError {
        ...error
      }
      ... on SubmitChargeCardApplicationError {
        ...error
      }
      ... on Error {
        ...error
      }
    }
  }
  ${error}
`;
